import { axios } from '@/utils/request'
const api = {
  source: '/order/AccessoryOrder',
}
// // 配件订单列表
// export function getAccessoryOrderlist (parameter) {
//   return axios({
//     url: api.source +'/list',
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }
export function getPriceAuditlist (parameter) {
  return axios({
    url: '/order/PriceAudit/list',
    method: 'get',
    params: parameter,
  })
}